import { render, staticRenderFns } from "./Venues.vue?vue&type=template&id=1b50b43e&scoped=true&"
import script from "./Venues.vue?vue&type=script&lang=js&"
export * from "./Venues.vue?vue&type=script&lang=js&"
import style0 from "./Venues.vue?vue&type=style&index=0&id=1b50b43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b50b43e",
  null
  
)

export default component.exports